import { render, staticRenderFns } from "./CardFiltrosDashBoardOperacao.vue?vue&type=template&id=2cfe0ff8&lang=pug"
import script from "./CardFiltrosDashBoardOperacao.vue?vue&type=script&lang=js"
export * from "./CardFiltrosDashBoardOperacao.vue?vue&type=script&lang=js"
import style0 from "./CardFiltrosDashBoardOperacao.vue?vue&type=style&index=0&id=2cfe0ff8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports